import React from 'react';
import './MenuItemCard.css';

const MenuItemCard = ({ item, onEdit, onDelete, onToggleAvailability }) => {
  return (
    <div className="menu-item-card">
      <div className="card-image-section">
        <div className="image-placeholder">
          {item.images && Array.isArray(item.images) && item.images.length > 0 && item.images[0] ? (
            <img 
              src={item.images[0]} 
              alt={item.name}
              onError={(e) => {
                console.error('Error loading image in MenuItemCard:', item.images[0]);
                e.target.style.display = 'none';
                e.target.parentElement.innerHTML = '<span class="image-icon">🍽️</span>';
              }}
            />
          ) : (
            <span className="image-icon">🍽️</span>
          )}
        </div>
        <div className="image-overlay">
          <span>View</span>
        </div>
        <div className="image-badges">
          {item.isPopular && (
            <span className="badge popular-badge">Popular</span>
          )}
          {item.isNew && (
            <span className="badge new-badge">New</span>
          )}
        </div>
      </div>

      <div className="card-content">
        <div className="availability-toggle-wrapper">
          <label className="toggle-switch">
            <input
              type="checkbox"
              checked={item.isAvailable}
              onChange={onToggleAvailability}
            />
            <span className="toggle-slider"></span>
          </label>
          <span className="availability-text">
            {item.isAvailable ? 'Available' : 'Sold Out'}
          </span>
        </div>

        <h3 className="item-name">{item.name}</h3>

        <div className="category-tag">
          <span className="category-icon">📁</span>
          <span>{item.category}</span>
        </div>

        <p className="item-description">{item.description}</p>

        <div className="item-price">PKR {item.price.toLocaleString()}</div>

        <div className="tags-row">
          {item.tags.map((tag, index) => (
            <span key={index} className="item-tag">{tag}</span>
          ))}
        </div>
      </div>

      <div className="card-footer">
        <button className="action-btn edit-btn" onClick={onEdit}>
          ✏️ Edit
        </button>
        <button className="action-btn delete-btn" onClick={onDelete}>
          🗑️ Delete
        </button>
      </div>
    </div>
  );
};

export default MenuItemCard;

